import { useSignedUrl } from "@/lib/media/useSignedUrl";

interface SignedImageProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src"> {
  src: string | null | undefined;
}

/** Drop-in <img> replacement that transparently resolves signed storage URLs. */
const SignedImage = ({ src, alt, ...rest }: SignedImageProps) => {
  const signedSrc = useSignedUrl(src);
  if (!signedSrc) return null;
  return <img src={signedSrc} alt={alt} {...rest} />;
};

export default SignedImage;
